export default {
      id: "icon_pill-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "sprite.svg#icon_pill",
      toString: function () {
        return this.url;
      }
    }